<div class="inner-page-wrapper py-24">
    <span class="leading-21 text-14 text-grey-400" [innerHTML]="safeData()"></span>
</div>
